import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isIdentityVerificationModalOrRoute } from "@faire/retailer-visitor-shared/components/App/AppModals/isIDV";
import { HeaderPriorityProvider } from "@faire/retailer-visitor-shared/components/HeaderPriorityRenderer/HeaderPriorityPriovider";
import { AppNudgeProvider } from "@faire/retailer-visitor-shared/features/Nudges/useAppNudgeStore";
import { isMobileApp } from "@faire/retailer-visitor-shared/lib/isMobileApp";
import { useStickyNavContentPositions } from "@faire/retailer-visitor-shared/navbar/useStickyNavContentPositions";
import React from "react";
import { ToastContainer } from "../../../Wrapper/ToastContainer";
import { useClassName } from "../../../Wrapper/useClassName";
import { useNonStickyHeader } from "../../../Wrapper/useNonStickyHeader";
import { useResizeRefCallback } from "../../../Wrapper/useResizeRefCallback";
import { useStyle } from "../../../Wrapper/useStyle";
export var LightweightWrapper = function(param) {
    var children = param.children;
    var _useResizeRefCallback = useResizeRefCallback(), contentCallback = _useResizeRefCallback.contentCallback, contentRef = _useResizeRefCallback.contentRef;
    var shouldRetainOriginalPosition = useStickyNavContentPositions().shouldRetainOriginalPosition;
    var nonStickyHeader = useNonStickyHeader({
        hasLinkedPOS: false
    });
    var style = useStyle({
        bannerHeight: 0,
        contentRef: contentRef,
        hasNoTopBanner: false,
        isNotificationPreviewVisible: false,
        isShowingMarketCountdownBanner: false,
        nonStickyHeader: nonStickyHeader,
        notificationPreview: undefined,
        shouldRetainOriginalPosition: shouldRetainOriginalPosition,
        shouldShowSaleAnnouncementTooltip: false
    });
    var className = useClassName({
        nonStickyHeader: nonStickyHeader,
        shouldRetainOriginalPosition: shouldRetainOriginalPosition
    });
    if (isMobileApp() && isIdentityVerificationModalOrRoute()) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(HeaderPriorityProvider, {
        value: {
            isNotificationPreviewVisible: false
        },
        children: [
            /*#__PURE__*/ _jsx(AppNudgeProvider, {
                children: /*#__PURE__*/ _jsx("div", {
                    "data-test-id": "header-content",
                    ref: contentCallback,
                    className: className,
                    style: style,
                    children: children
                })
            }),
            /*#__PURE__*/ _jsx(ToastContainer, {
                style: style
            })
        ]
    });
};
